<script setup lang="ts">
type MapLayerButton = 'roadmap' | 'satellite';

interface AppMapLayerSwitcherProps {
  selected: MapLayerButton;
  roadmapText: string;
  satelliteText: string;
}

const props = defineProps<AppMapLayerSwitcherProps>();

interface AppMapLayerSwitcherEmits {
  (eventName: 'roadmap-selected'): void;
  (eventName: 'satellite-selected'): void;
}

const emit = defineEmits<AppMapLayerSwitcherEmits>();

function onClick(selected: MapLayerButton): void {
  if (props.selected === selected) {
    return;
  }

  if (selected === 'roadmap') {
    emit('roadmap-selected');
  }

  if (selected === 'satellite') {
    emit('satellite-selected');
  }
}
</script>

<template>
  <div class="app-map-layer-switcher">
    <button
      class="roadmap-button"
      :class="{ selected: props.selected === 'roadmap' }"
      @click="onClick('roadmap')"
    >
      <div class="text">{{ props.roadmapText }}</div>
    </button>
    <button
      class="satellite-button"
      :class="{ selected: props.selected === 'satellite' }"
      @click="onClick('satellite')"
    >
      <div class="text">{{ props.satelliteText }}</div>
    </button>
  </div>
</template>

<style scoped lang="scss">
.app-map-layer-switcher {
  --button-size: 74px;
  --border-size: 3px;

  display: flex;
  gap: 70px;

  .roadmap-button,
  .satellite-button {
    all: unset;
    width: var(--button-size);
    height: var(--button-size);
    border-radius: var(--border-radius-8);
    border: var(--border-size) solid var(--color-white);

    display: flex;
    justify-content: center;
    align-items: flex-end;

    &.selected {
      border: var(--border-size) solid var(--color-soft-black);

      .text {
        @include font-label-l-bold;
      }
    }

    .text {
      transform: translateY(30px);
      @include font-label-l-light;
    }
  }

  .roadmap-button {
    background-image: url('./roadmap.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 1;
    position: relative;
  }

  .satellite-button {
    background-image: url('./satellite.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 1;
    position: relative;
  }
}
</style>
